/** The Thai block, U+0E00–U+0E7F (escaped, so web/src holds no Thai literal: test/noThaiLiterals.test.ts). */
const THAI = /[\u0E00-\u0E7F]/;

export function containsThai(text: string): boolean {
  return THAI.test(text);
}

/** lang attribute for user text: Thai text must declare lang="th" so :lang(th) rules apply (UX-01 §4.6). */
export function langFor(text: string): "th" | undefined {
  return containsThai(text) ? "th" : undefined;
}
